import { Reveal } from "./motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const faqs = [
  { q: "Are invisible grills really strong enough for safety?", a: "Yes. We use high-tension SS304/SS316 steel cables spaced under 3 inches apart and anchored into aluminium tracks. They withstand significant force and are ideal for child and pet safety on any floor." },
  { q: "Will they block my balcony view or airflow?", a: "No. The cables are thin and near-transparent, so your skyline view, natural light and breeze stay fully intact — that's the whole point of invisible grills." },
  { q: "Do they rust in the Hyderabad monsoon?", a: "Our SS316 marine-grade steel is highly corrosion resistant. With correct installation and periodic tension checks, they stay rust-free for years, backed by our warranty." },
  { q: "How long does installation take?", a: "Most standard balconies are completed within 3–5 hours after measurement. Larger or custom jobs may take a day. We schedule at your convenience." },
  { q: "What warranty do you provide?", a: "We offer a written warranty of up to 10 years on materials, plus free tension check-ups. Terms depend on the grade and product chosen." },
  { q: "How do I get a price?", a: "Share your location and balcony/window details via the quote form or WhatsApp. We give a transparent, no-obligation estimate — often the same day." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 md:py-36 bg-steel-50">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10">
        <Reveal className="mb-12 text-center">
          <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">Good to know</p>
          <h2 className="font-display font-black tracking-tighter text-steel-900 text-4xl md:text-6xl leading-none">
            Frequently asked
          </h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-steel-300">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-bold text-lg text-steel-900 hover:text-steel-700 hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-steel-600 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
